import React, { useRef } from 'react';
import { Controller, UseFormMethods } from 'react-hook-form';
import AcknowledgementType from 'src/models/leasing/AcknowledgementType';
import Card from 'src/components/common/Card.redesign';
import { ContextMenuAction } from 'src/components/common/ContextMenu';
import '../../../../../common/styles/hover-highlight.scss';
import ReactQuill from 'react-quill';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import SignatureBlock from 'src/models/leasing/SignatureBlock';

interface ISignatureCard extends Partial<Pick<UseFormMethods, 'register' | 'errors' | 'control'>> {
    ackType?: AcknowledgementType[];
    signature?: SignatureBlock;
    // typeSelected?: number;
    signatureOnly?: boolean;
    index?: number;
    deleteCard?: (index: number) => void;
    onChange?: () => void;
}

const SignatureCard: React.FC<ISignatureCard> = (props) => {
    const signatureBlock = '<p>________________________________________</p><p>[SIGNATURE NAME/TITLE]</p>';

    const actions: ContextMenuAction[] = [{ text: 'Delete Signature', action: () => props?.deleteCard(props.index) }];
    const editor = useRef<ReactQuill>();

    return (
        <Card
            className="card-highlight"
            contextActions={actions}
            newContext={true}
            showMenu={true}
            style={{
                display: 'flex',
                justifyContent: 'space-around',
                width: props.signatureOnly ? '50%' : '98%'
            }}
        >
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                    gap: '5rem',
                    alignItems: 'center',
                }}
            >
                {/* <div style={{ display: 'none' }}>
                    <input
                        type="hidden"
                        name={`signatureBlocks[${props.index}].id`}
                        ref={props.register}
                        defaultValue={props.control._formValues?.signatureBlocks?.[props.index]?.id}
                    />
                    <input
                        type="hidden"
                        name={`signatureBlocks[${props.index}].acknowledgementId`}
                        ref={props.register}
                        defaultValue={props.control._formValues?.signatureBlocks?.[props.index]?.acknowledgementId}
                    />
                </div>                 */}
                {props.signatureOnly && (
                    <div style={{ display: 'flex' }}>
                        <RHFInputBox label="Owner" name={`signatureBlocks[${props?.index}].ownerName`} register={props.register} defaultVal={props.signature.ownerName} style={{ width: '150px' }} />
        
                        <RHFInputBox label="Title" name={`signatureBlocks[${props?.index}].title`} register={props.register} defaultVal={props.signature.title} style={{ width: '150px' }} />
                    </div>
                )}
                {!props.signatureOnly && (
                    <Controller
                        name={`signatureBlocks[${props?.index}].textRTE`}
                        control={props.control}
                        defaultValue={props.signature?.textRTE ?? signatureBlock}
                        render={({ onChange, onBlur, value }) => (
                            <ReactQuill 
                                style={{ width: '100%' }} 
                                ref={editor} 
                                theme="snow" 
                                value={value} 
                                onChange={onChange} 
                                onBlur={onBlur} 
                            />
                        )}
                    />
                )}
            </div>
        </Card>
    );
};

export default SignatureCard;



// WEBPACK FOOTER //
// ./src/components/project/sections/LeasingComponents/redesign/SignatureBlockComponents/SignatureCard.redesign.tsx